<template>
    <div>

        <section class="partner">

            <header class="partner__header">

                <img src="/img/partner/logo-large-white.svg" class="partner__header__img pointer" @click="goLanding">

            </header>

            <div class="partner__body" v-if="isAPartner">

                <div class="partner__body__top">
                    <section class="partner__infos">

                        <div>
                            <img src="/img/partner/picture-cleanfox.png" class="partner__infos__logo partner__infos__logo__left">
                            <img :src="infos.img" class="partner__infos__logo partner__infos__logo__right">
                        </div>

                        <p class="partner__infos__title">{{ $tc('partner_title', 0, {partner_name: infos.name}) }}</p>

                        <p class="partner__infos__text">{{ $tc('partner_subtitle', 0, {partner_name: infos.name}) }}</p>

                        <div class="partner__infos__cite">
                            <img :src="infos.img" class="partner__infos__cite__img">

                            <markdown class="partner__infos__cite__text" :text="infos.text"></markdown>
                        </div>

                        <button class="partner__infos__copy">
                            <div class="partner__infos__copy__left pointer" @click="copyCode">
                                <p class="partner__infos__copy__title">{{ infos.code }}</p>
                                <p class="partner__infos__copy__text" :class="{ 'partner__infos__copy__text__clicked': clicked }">{{ computedClicked }}</p>
                            </div>
                            <div v-show="isDesktop">
                                <a class="partner__infos__create pointer" v-if="isMobile" href="https://app.adjust.com/2p936hy">{{ $t('create_my_account') }}</a>
                                <button class="partner__infos__create pointer" v-else @click="clean">{{ $t('create_my_account') }}</button>
                            </div>
                        </button>

                        <a class="partner__infos__create" v-show="!isDesktop" v-if="isMobile" href="https://app.adjust.com/2p936hy">{{ $t('create_my_account') }}</a>
                        <button class="partner__infos__create" v-show="!isDesktop" v-else @click="clean">{{ $t('create_my_account') }}</button>

                    </section>

                    <section class="partner__tips" :class="{'partner__tips__area-free': !showTreesArea}">

                        <div class="partner__tips__line">
                            <div class="partner__tips__area partner__tips__area__1">
                                <div class="partner__tips__item partner__tips__item__1">
                                    <p class="partner__tips__item__title">{{ referees }}</p>
                                    <p class="partner__tips__item__text">{{ $tc('nb_registered_partner', referees, {partner_name: infos.name}) }}</p>
                                </div>
                            </div>

                            <div class="partner__tips__area partner__tips__area__2" v-show="showTreesArea">
                                <div class="partner__tips__item partner__tips__item__2">
                                    <p class="partner__tips__item__title">{{ sqmByPartner }}</p>
                                    <p class="partner__tips__item__text">{{ $t('partner_trees_title') }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="partner__tips__line">
                            <div class="partner__tips__area partner__tips__area__3">
                                <div class="partner__tips__item partner__tips__item__3">
                                    <p class="partner__tips__item__title">{{ deleted }}</p>
                                    <p class="partner__tips__item__text">{{ $tc('statistics_deleted', deleted) }}</p>
                                </div>
                            </div>

                            <div class="partner__tips__area partner__tips__area__4">
                                <div class="partner__tips__item partner__tips__item__4">
                                    <p class="partner__tips__item__title">{{ computedCo2Text }}</p>
                                    <p class="partner__tips__item__text">{{ computedCo2Saved }}</p>
                                </div>
                            </div>
                        </div>

                    </section>

                </div>

                <section class="partner__articles">

                    <article class="partner__article">
                        <div class="partner__article__container">
                            <img src="/img/partner/mailbox.svg" class="partner__article__img">
                        </div>
                        <h2 class="partner__article__title">{{ $t('How_does_Cleanfox_works') }}</h2>
                        <p class="partner__article__text">{{ $t('partner_how_to') }}</p>
                        <a class="partner__article__cta" :href="`/${lang}/fox/faq`">{{ $t('more_title') }}</a>
                    </article>

                    <div class="partner__articles__gap"></div>

                    <article class="partner__article">
                        <div class="partner__article__container partner__article__container__weforest">
                            <img src="/img/partner/logo-weforest.webp" class="partner__article__img__weforest">
                        </div>
                        <h2 class="partner__article__title">{{ $t('partner_about_weforest_title') }}</h2>
                        <p class="partner__article__text">{{ $t('partner_about_weforest_description') }}</p>
                        <a class="partner__article__cta" href="https://www.weforest.org/partner/cleanfox" target="_blank" rel="noopener noreferrer nofollow">{{ $t('partner_about_weforest_cta') }}</a>
                    </article>

                </section>


                <section class="partner__faq">

                    <article class="partner__faq__item" v-for="(faq, index) in faqs">
                        <div class="partner__faq__header pointer" @click="toggleFaq(index)">
                            <h2 class="partner__faq__title">{{ $t(faq.title) }}</h2>
                            <img :src="faq.checked ? '/img/partner/arrow-up.svg' : '/img/partner/arrow-down.svg'" class="partner__faq__arrow">
                        </div>
                        <div class="partner__faq__body" v-show="faq.checked">
                            <p class="partner__faq__text">{{ $t(faq.text) }}</p>
                        </div>
                    </article>

                </section>

            </div>

        </section>

        <footer-green></footer-green>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Api from '@/api'

import Storage from '@/helpers/storage'

import Conversion from '@/modules/conversion'
import Partners from '@/modules/partners'
import Tag from '@/modules/tag'
import UserAgent from '@/modules/userAgent'
import UserFlow from '@/modules/userFlow'

import FooterGreen from '@/components/FooterGreen'
import LottieLoader from '@/components/lottie/LottieLoader'
import Markdown from '@/components/Markdown'

export default {

    name: 'partner',

    components: {FooterGreen, LottieLoader, Markdown},

    computed: {

        ...Vuex.mapGetters(['lang']),

        isMobile() {
            return UserAgent.is.mobile()
        },

        computedClicked: function () {

            return this.clicked ? this.$t('we_forest_code_copied') : this.$t('partner_cta')

        },

        isAPartner: function () {

            return this.infos && Object.keys(this.infos).length > 0

        },

        isDesktop: function () {
            return this.$mq !== 'sm'
        },

        playStore() {
            return 'https://play.google.com/store/apps/details?id=io.cleanfox.android&hl=' + this.lang
        },

        computedCo2Text() {
            return this.co2 >= 1000
                ? (this.co2 / 1000).toFixed(2)
                : (this.co2 || 0).toFixed(2)
        },

        computedCo2Saved() {
            return this.co2 >= 1000
                ? this.$tc('partner_carbon_saved_kg', Math.trunc(this.co2 / 1000))
                : this.$tc('partner_carbon_saved_g', Math.trunc(this.co2 || 0))
        },

        showTreesArea() {
            return this.partnerCode !== 'ETLMSF'
        }

    },

    data() {
        return {
            title: '',
            text: '',
            infos: {},
            clicked: false,
            faqs: [
                {title: 'partner_digital_pollution', text: 'partner_digital_pollution_2', checked: false},
                {title: 'landing_web_questions_subtitle_carbon', text: 'landing_web_questions_text_carbon', checked: false},
                {title: 'How_does_Cleanfox_works', text: 'How_does_Cleanfox_works_2', checked: false},
                {title: 'partner_faq_error', text: 'partner_faq_error_2', checked: false}
            ],
            referees: 0,
            sqmByPartner: 0,
            deleted: 0,
            co2: 0,
            appStore: 'https://apps.apple.com/app/id1136298377?mt=8'
        }
    },

    created() {

        this.partnerCode = this.$route.params.name

        Partners.getPartner(this.partnerCode)
            .then(result => {

                this.infos = result

                if (!this.isAPartner) {
                    this.exit()
                }

                UserFlow.setPage(this, `partner_${this.partnerCode}`)

                Api.sponsorship.getByPartner(this.partnerCode)
                    .then(data => {
                        this.referees = data.referees
                        this.sqmByPartner = Math.round(data.sqm)
                        this.deleted = data.deleted
                        this.co2 = data.co2
                    })
                    .catch(() => {
                    })


            })
            .catch(() => {
            })

    },

    methods: {

        exit() {

            if (Storage.getItem('token')) {

                this.$router.push({path: '/newsletters'})
            } else {

                this.$router.push({path: '/'})
            }
        },

        goLanding() {

            this.$router.push({path: '/'})
        },

        clean() {

            Tag.clickAmplitude(this, `partner_${this.$route.params.name}_clean`)

            if (UserAgent.is.mobile()) {
                window.open('https://app.adjust.com/2p936hy', '_blank', 'rel="noopener,noreferrer,nofollow"')
            } else {
                Storage.setItem('partnerCode', this.infos.code)
                this.goLanding()
            }
        },

        copyCode() {

            Storage.setItem('partnerCode', this.infos.code)

            // createTextArea
            const textArea = document.createElement('textArea')
            textArea.value = this.infos.code
            textArea.setAttribute('readonly', 'readonly')
            document.body.appendChild(textArea)

            // selectText
            if (UserAgent.is.ios()) {
                const range = document.createRange()
                range.selectNodeContents(textArea)
                const selection = window.getSelection()
                selection.removeAllRanges()
                selection.addRange(range)
                textArea.setSelectionRange(0, 999999)
            } else {
                textArea.select()
            }

            // copyToClipboard
            document.execCommand('copy')
            document.body.removeChild(textArea)

            this.clicked = true
        },

        toggleFaq(index) {
            this.faqs[index].checked = !this.faqs[index].checked
        },

        goFaq() {
            this.$router.push({path: '/faq'})
        }
    }
}
</script>

<style lang="scss" scoped>

.partner {
    background-color: $blue;
    background-image: url('/img/partner/background-mobile.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;

    @media screen and (min-width: $above-mobile-length) {
        background-image: url('/img/partner/background-desktop.svg');
    }

    &__body {
        display: flex;
        flex-direction: column;
        align-items: center;
        @media screen and (min-width: $above-mobile-length) {
            max-width: 772px;
            padding: 80px 16px 80px;
        }

        &__top {
            @media screen and (min-width: $above-mobile-length) {
                display: flex;
                flex-direction: row;
            }
        }
    }

    &__header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px;
        background-color: $white;
        border-bottom: 2px solid $timberwolf;

        &__img {
            height: 40px;
            object-fit: contain;
        }
    }

    &__infos {
        background-color: $white;
        padding: 32px 20px;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-mobile-length) {
            border-radius: 20px;
            align-items: flex-start;
            text-align: left;
            padding: 64px 32px 32px;
        }

        &__logo {
            width: 96px;
            object-fit: contain;
            border-radius: 120px;
            border: solid 4px $timberwolf;

            &__left {
                margin-right: -10px;
            }

            &__right {
                margin-left: -10px;
            }
        }

        &__title {
            font-size: 40px;
            font-weight: 600;
            line-height: 1.1;
            letter-spacing: -0.4px;
            margin-top: 20px;
            @media screen and (min-width: $above-mobile-length) {
                font-size: 56px;
                font-weight: 600;
                line-height: 1.07;
                letter-spacing: -0.56px;
                margin-top: 40px;
            }
        }

        &__text {
            font-size: 16px;
            line-height: 1.5;
            margin-top: 24px;
            @media screen and (min-width: $above-mobile-length) {
                font-size: 24px;
                line-height: 1.33;
                margin-top: 16px;
            }
        }

        &__cite {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            background-color: $timberwolf;
            border-radius: 20px;
            padding: 16px;
            text-align: left;
            margin-top: 20px;
            @media screen and (min-width: $above-mobile-length) {
                margin-top: 40px;
            }

            &__img {
                width: 40px;
                object-fit: contain;
                margin-right: 16px;
                border-radius: 72px;
                @media screen and (min-width: $above-mobile-length) {
                    width: 56px;
                }
            }

            &__text {
                font-size: 14px;
                font-weight: 500;
                line-height: 1.43;
            }
        }

        &__copy {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 10px;
            background-color: $timberwolf;
            border-radius: 32px;
            border: dashed 2px $stone;
            margin-top: 20px;
            @media screen and (min-width: $above-mobile-length) {
                flex-direction: row;
                align-items: center;
                width: fit-content;
            }

            &__left {
                @media screen and (min-width: $above-mobile-length) {
                    margin-right: 24px;
                }
            }

            &__title {
                font-size: 16px;
                font-weight: 600;
                line-height: 1.25;
                letter-spacing: 1.92px;
            }

            &__text {
                font-size: 12px;
                font-weight: 500;
                line-height: 1.33;
                color: $moon;

                &__clicked {
                    color: $lime
                }
            }
        }

        &__create {
            width: 100%;
            padding: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 72px;
            background-color: $forest;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.25;
            color: $white;
            margin-top: 16px;
            @media screen and (min-width: $above-mobile-length) {
                margin: 0;
                padding: 14px 20px;
            }
        }

        &__link {
            margin-top: 16px;
            font-size: 16px;
            line-height: 1.5;
        }
    }

    &__tips {
        margin-top: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;

        @media screen and (min-width: $above-mobile-length) {
            display: flex;
            flex-direction: column;
            margin: 0;
            gap: 0;
        }

        &__line {
            display: flex;
            flex-direction: row;
            padding: 0 16px;
            align-items: center;
            justify-content: center;
            @media screen and (min-width: $above-mobile-length) {
                flex-direction: column;
            }
        }

        &__area-free {
            display: flex;
            justify-content: center;

            @media screen and (min-width: $above-mobile-length) {
                justify-content: flex-start;
            }
        }

        &__area {
            display: flex;
            align-items: center;
            @media screen and (min-width: $above-mobile-length) {
                margin: 0 0 20px 0;
            }

            &__1 {
                justify-content: flex-end;
            }

            &__2 {
                justify-content: flex-start;
            }

            &__3 {
                justify-content: flex-end;
            }

            &__4 {
                justify-content: flex-start;
            }
        }


        &__item {
            width: 164px;
            height: 164px;
            background-color: $white;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 12px;
            border-radius: 16px;
            background-repeat: no-repeat;
            background-position: bottom;
            background-size: contain;
            margin: 4px;
            @media screen and (min-width: $above-mobile-length) {
                width: 178px;
                height: 178px;
                margin: 0;
            }

            &__1 {
                background-image: url('/img/partner/illustration-account-created.svg');
            }

            &__2 {
                background-image: url('/img/partner/illustration-tree-planted.svg');
            }

            &__3 {
                background-image: url('/img/partner/illustration-mail-deleted.svg');
            }

            &__4 {
                background-image: url('/img/partner/illustration-co-2-saved.svg');
            }

            &__title {
                font-size: 24px;
                font-weight: 600;
                line-height: 1.17;
            }

            &__text {
                margin-top: 2px;
                font-size: 12px;
                font-weight: 500;
                line-height: 1.17;
                color: $moon;
            }
        }
    }

    &__articles {
        padding: 20px;
        @media screen and (min-width: $above-mobile-length) {
            display: flex;
            flex-direction: row;
            padding: 0;
        }

        &__gap {
            @media screen and (min-width: $above-mobile-length) {
                width: 20px;
            }
        }
    }

    &__article {
        margin-top: 20px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        border-radius: 20px;
        background-color: $white;
        align-items: flex-start;
        text-align: left;
        @media screen and (min-width: $above-mobile-length) {
            flex: 1;
            margin-top: 40px;
        }

        &__container {
            width: 100%;
            border-radius: 8px;
            background-color: $mint;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            height: 200px;

            &__weforest {
                align-items: center;
                background-color: $rifle;
            }
        }

        &__img {
            width: 128px;
            object-fit: contain;

            &__weforest {
                width: 220px;
                object-fit: contain;
            }
        }

        &__title {
            margin-top: 32px;
            font-size: 20px;
            font-weight: 600;
            line-height: 1.2;
            letter-spacing: -0.2px;
        }

        &__text {
            margin-top: 8px;
            font-size: 16px;
            line-height: 1.5;
            flex-grow: 1;
        }

        &__cta {
            margin-top: 32px;
            padding: 10px 20px;
            background-color: $mint;
            border-radius: 72px;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.25;
            color: $rifle;
        }
    }

    &__faq {
        padding: 32px 20px 40px;
        width: 100%;

        @media screen and (min-width: $above-mobile-length) {
            padding: 40px 0 40px;
        }

        &__item {
            margin-top: 8px;
            padding: 20px;
            display: flex;
            flex-direction: column;
            background-color: $white;
            border-radius: 12px;
        }

        &__header {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            text-align: left;
        }

        &__title {
            font-size: 16px;
            font-weight: 600;
            line-height: 1.5;
            margin-right: 12px;
            @media screen and (min-width: $above-mobile-length) {
                font-size: 20px;
                font-weight: 600;
                line-height: 1.2;
            }
        }

        &__arrow {
            width: 20px;
            object-fit: contain;
        }

        &__body {
            margin-top: 20px;
        }

        &__text {
            font-size: 14px;
            line-height: 1.43;
            text-align: left;
            @media screen and (min-width: $above-mobile-length) {
                font-size: 16px;
                line-height: 1.5;
            }
        }
    }
}

</style>
